import * as IconsMap from "./icon-static-map"
import { IconComponent } from "./types"

type IconType = keyof typeof IconsMap

export type { IconType }

const IconStaticMap = IconsMap as Record<IconType, IconComponent>
export { IconStaticMap }
